// :cow: Cosmose CONFIDENTIAL :iso:
import { ConfigService } from '@med/app/core/config/config.service';
import { RavenErrorHandler } from '@med/app/core/error-handler/raven-error-handler';
import { DevErrorHandler } from '@med/app/core/error-handler/dev-error-handler';

export const errorHandlerFactory = (configService: ConfigService) => {
  if (configService.getConfig().sentry) {
    return new RavenErrorHandler();
  } else {
    return new DevErrorHandler();
  }
};
